import {
  createFrontendModule,
  NotFoundErrorPage,
} from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import { ByxNotFound } from './StatusPanel';

/**
 * Replaces the app's `core-not-found-error-page` (same name, so it is an
 * override of the stock "ERROR 404: PAGE NOT FOUND" page) with the pt-BR
 * Página não encontrada, wherever the stock not-found component is used.
 */
export const byxNotFoundErrorPage = SwappableComponentBlueprint.make({
  name: 'core-not-found-error-page',
  params: define =>
    define({
      component: NotFoundErrorPage,
      loader: () => ByxNotFound,
    }),
});

/**
 * Página não encontrada (U5-9, AC-30). The app's swappable components only
 * accept extensions of the app plugin itself.
 */
export const errorPagesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [byxNotFoundErrorPage],
});
